import React, { useState, useEffect } from 'react'
import styles from './interviews.module.scss';
import CSSLoader from '../../shared/cssLoader';
import { Card, Col, Row, Container, Image, Button, Badge, Modal, Alert } from 'react-bootstrap';
import { getAllInterviews, getInterviewerRSVP } from '../../../services/util/interviews';
import { Helmet } from "react-helmet";
import Avatar from 'react-avatar';
import ReactGA from 'react-ga4';
import CustomNavbar from '../customNavbar';
import { CustomButton } from '../../shared/customButton';
import { CustomConfirmationModal } from '../../shared/customConfirmationModal';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import { CustomCheckBox } from '../../shared/customCheckBox';
import { CustomAlertBox } from '../../shared/customAlertBox';
import { checkCalendarAvailability } from '../../../services/util/interviews'
import { CustomStatusLabel } from '../../shared/customStatusLabel'
import Select from 'react-select';
import { CustomSearch } from '../../shared/customSearch';
import makeAnimated from 'react-select/animated';

const Interviews = (props) => {
    const animatedComponents = makeAnimated();
    const [searchValue, setSearchValue] = useState('');
    const [selectedFilter, setSelectedFilter] = useState('All');


    let concatValue;
    let time_difference;
    let minute_difference;
    let concatDateValue;
    let overdueTime;
    const [isLoading, setLoading] = useState(false);
    let [isRSVPModalOpen, setRSVPModalOpen] = useState(false);
    let [isInterviewDetailsLoading, setInterviewDetailsLoading] = useState(false);

    let [interviewDetailsObj, setInterviewDetailsObj] = useState({
        interview_details: {
            schedule: {},
            other_interviewers: []
        }
    });
    const [failModal, setFailModal] = useState(false);
    let [respondValues, setRespondValues] = useState();
    let [interviewValues, setInterviewValues] = useState([]);
    let [filteredValues, setFilteredValues] = useState([]);
    let [isSubmissionLoading, setSubmissionLoading] = useState(false);
    let [isAcknowledgeConfirmed, setAcknowledgeConfirmed] = useState(false);
    let [noSearchData, setNoSearchData] = useState(false)
    let [isURLLoading, setURLLoading] = useState(false);
    let moment = require('moment-timezone');


    //defaul dropdown value of filter types
    let [defaultFilterType, setDefaultFilterType] = useState({
        label: "All",
        value: 100
    })

    //dropdown values of filter types
    const filterType = [
        {
            label: "All",
            value: 100
        },
        {
            label: "Pending",
            value: 10
        },
        {
            label: "Now",
            value: 0
        },
        {
            label: "Overdue",
            value: -10
        }
    ];

    const breadcrumb = [
        {
            pathaddress: '/app/company/interviews',
            pathname: 'Interviews',
            isActive: false,
            key: 1 + 'interviews'
        },
    ]

    const breacrumbText = 'Here you can see all the interviews that you have been assigned as an interviewer. Go inside to each card to view more details'


    function startInterview(value) {
        props.history(`/company/interviews/${value}`);
    }

    const searchValues = (searchValue) => {
        const searchVal = searchValue.toLowerCase().trim();
        setSearchValue(searchVal);

        const filtered = interviewValues.filter(entry =>
            Object.values(entry).some(val =>
                typeof val === "string" && val.toLowerCase().includes(searchVal)
            )
        );
        setFilteredValues(filtered);
        setNoSearchData(filtered.length === 0);
    };

    const markAsReviewerCanAttend = async (values) => {
        setInterviewDetailsLoading(true);
        setRSVPModalOpen(true);
        setRespondValues(values)
        let respond = await checkCalendarAvailability(values.session_id);
        if (respond.success === true) {
            setInterviewDetailsObj(respond.data);
            setInterviewDetailsLoading(false);
        } else {
            setInterviewDetailsLoading(false);
            setRSVPModalOpen(false);
        }
    }

    const closeAsReviewerCanAttendModal = () => {
        setRSVPModalOpen(false);
        setAcknowledgeConfirmed(false);
    }

    //submit as attending
    const submitSuccess = async () => {
        setSubmissionLoading(true);
        let result = await getInterviewerRSVP(respondValues.session_id, respondValues.rsvp);
        if (result.success === true) {
            setSubmissionLoading(false);
            setFailModal(false);
            setRespondValues(null);
            setRSVPModalOpen(false);
            getAllInterviewsDetails();
        } else {
            setSubmissionLoading(false);
        }
    }
    //submit as not attending
    const submitFail = async () => {
        setSubmissionLoading(true);
        let result = await getInterviewerRSVP(respondValues.session_id, respondValues.rsvp);
        if (result.success === true) {
            setSubmissionLoading(false);
            setRespondValues(null)
            setFailModal(false)
            getAllInterviewsDetails();
        } else {
            setSubmissionLoading(false);
        }
    }

    const timesBtnChecked = (value) => {
        setFailModal(true)
        setRespondValues(value)
    }

    const closeAlertBox = () => {
        setRespondValues(null)
        setFailModal(false)
    }

    const getAllInterviewsDetails = async () => {
        setLoading(true)
        const values = await getAllInterviews();
        if (values.success === true) {
            setInterviewValues(values.data)
            setLoading(false)

        } else {
            setLoading(false)
        }
    }

    function addMaxViewLength(values, size) {
        concatValue = values.length > size ? values.slice(0, size - 1) + "…" : values;
    }

    function addMaxViewLengthToDate(values, size) {
        concatDateValue = values.length > size ? values.slice(0, size - 1) + "…" : values;
    }

    const changeAcknowledgeState = () => {
        setAcknowledgeConfirmed(!isAcknowledgeConfirmed);
    }

    const connectCalendar = () => {
        window.location.replace('/app/my-settings/calendar');
    }

    const getCurrentTimeDifference = (value) => {
        //set time difference and minute difference to 0 before set new value
        time_difference = 0;
        minute_difference = 0;
        overdueTime = 0;

        let current_time_utc = moment().utc();
        let end_time = moment(value).utc();
        time_difference = parseInt(moment.duration(end_time.diff(current_time_utc)).asHours());
        if (time_difference < 12) {
            minute_difference = parseInt(moment.duration(end_time.diff(current_time_utc)).asMinutes()) - time_difference * 60;
            overdueTime = parseInt(moment.duration(end_time.diff(current_time_utc)).asMinutes());

        }
    }

    const changeTimeStateType = async (type) => {
        setLoading(true)
        const respond = await getAllInterviews();
        if (respond.success === true) {
            if (type.value === 100) {

                setFilteredValues(respond.data);
            }
            else {
                const filtered = respond.data.filter(entry => entry.interview_time_state === type.value)
                setFilteredValues(filtered);
            }
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllInterviewsDetails();
    }, []);

    useEffect(() => {
        props.toggleInterviewView(false);
        ReactGA.initialize(`${process.env.REACT_APP_CUSTOMER_FLOW_GOOGLE_ANALYTICS_ID}`);
        ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search});
    }, [])

    useEffect(() => {
        if (searchValue === "") {

            setFilteredValues(interviewValues);
            setNoSearchData(false);
        }
    }, [interviewValues, searchValue]);

    return (
        <div>
            <Helmet>
                <title>Interviews | HireTrace</title>
            </Helmet>
            {isLoading === true ?
                (<div className={styles.loadingDiv}>
                    <Col sm={{ span: 4, offset: 4 }}>
                        <CSSLoader />
                    </Col>
                </div>)
                :
                (<div>

                    {/* Attending RSVP Response Modal Start*/}

                    <Modal
                        show={isRSVPModalOpen}
                        onHide={closeAsReviewerCanAttendModal}
                        backdrop="static"
                        keyboard={false}
                        centered
                        size="md"
                    >
                        {isInterviewDetailsLoading ?
                            (<div className={styles.loadingDivComponent}>
                                <Col sm={{ span: 4, offset: 4 }}>
                                    <CSSLoader />
                                </Col>
                            </div>)
                            :
                            <Modal.Body>
                                <Container className="p-4">
                                    <div className={styles.modalHeaderMainDiv}>
                                        <div className={styles.modalHeaderMainDiv}>
                                            <div className={styles.modalHeaderDiv}>
                                                <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle opacity="0.2" cx="28" cy="28" r="28" fill="#D2A20E" />
                                                    <path d="M28 38C33.5228 38 38 33.5228 38 28C38 22.4772 33.5228 18 28 18C22.4772 18 18 22.4772 18 28C18 33.5228 22.4772 38 28 38Z" stroke="#FFA500" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M28 24V28" stroke="#FFA500" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M28 32H28.01" stroke="#FFA500" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                            <div className={styles.popUpBoxTopicDiv}>
                                                <p className={styles.popUpBoxTopic}>RSVP Respond</p>
                                            </div>
                                        </div>
                                        <div className={styles.modalCancelBtnDiv}>
                                            <Button className={styles.modalCancelBtn} onClick={() => closeAsReviewerCanAttendModal()}>
                                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                    <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </Button>
                                        </div>
                                    </div>
                                    <div className={styles.stepSubtopicDiv}>
                                        <p className={styles.stepSubtopicName}>Review</p>
                                    </div>
                                    <Col className={styles.rsvpDetails}>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Candidate Name&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{interviewDetailsObj.interview_details.candidate_name}</span>
                                            </Col>
                                        </Row>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Position&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{interviewDetailsObj.interview_details.position}</span>
                                            </Col>
                                        </Row>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Interview Type&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{interviewDetailsObj.interview_details.interview_type === 0 ? 'Online video interview via Hiretrace' :  interviewDetailsObj.interview_details.interview_type === 2 ? 'Online video interview via Teams, Zoom or etc..' :'In-person interview'}</span>
                                            </Col>
                                        </Row>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Date and Time&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{moment.tz(interviewDetailsObj.interview_details.schedule.date_time, interviewDetailsObj.interview_details.schedule.time_zone).format('llll')}</span>
                                            </Col>
                                        </Row>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Time Zone&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{interviewDetailsObj.interview_details.schedule.time_zone}</span>
                                            </Col>
                                        </Row>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Location/Media&nbsp;:</span>&nbsp;<span className={styles.rowValues}>{(interviewDetailsObj.interview_details.interview_type === 1 && interviewDetailsObj.interview_details.interview_location_address) ? interviewDetailsObj.interview_details.interview_location_address : 'Online interview portal'}</span>
                                            </Col>
                                        </Row>
                                        <Row className={styles.DetailsRow}>
                                            <Col xs={12} className="mt-1 mb-1">
                                                <span className={styles.rowSubTitle}>Other Interviewers&nbsp;:</span><br />
                                                {(interviewDetailsObj.interview_details.other_interviewers).length > 0 ?
                                                    (interviewDetailsObj.interview_details.other_interviewers).map((value, index) => {
                                                        return (
                                                            <div>
                                                                <span key={index} className={styles.rowValues}><i className="fas fa-circle"></i>&nbsp;{value.email}&nbsp;-&nbsp;{value.name}</span>
                                                                <br />
                                                            </div>

                                                        )
                                                    })
                                                    :
                                                    <span className={styles.rowValuesNotAvailable}>No interviewers available</span>
                                                }
                                            </Col>
                                        </Row>
                                    </Col>
                                    <div className={styles.calendarTopicContainer}>
                                        <span className={styles.subtopicName}>Calendar Connection</span>
                                        {!interviewDetailsObj.is_calendar_connected &&
                                            <span className={styles.calenderConnectionLink} onClick={() => connectCalendar()}>Need to Connect ?</span>
                                        }
                                    </div>
                                    <Row className="mt-2 mb-3">
                                        <Col>
                                            <div className={styles.calendarLabelContainer}>
                                                <div>
                                                    <svg className={styles.calenderIcon} xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none">
                                                        <path d="M19 9.68541H1M14 1V5.3427M6 1V5.3427M7 16.1995L9 18.3708L13.5 13.4853M5.8 22.7135H14.2C15.8802 22.7135 16.7202 22.7135 17.362 22.3585C17.9265 22.0463 18.3854 21.548 18.673 20.9352C19 20.2384 19 19.3264 19 17.5023V8.3826C19 6.55849 19 5.64644 18.673 4.94972C18.3854 4.33687 17.9265 3.83861 17.362 3.52635C16.7202 3.17135 15.8802 3.17135 14.2 3.17135H5.8C4.11984 3.17135 3.27976 3.17135 2.63803 3.52635C2.07354 3.83861 1.6146 4.33687 1.32698 4.94972C1 5.64644 1 6.55849 1 8.3826V17.5023C1 19.3264 1 20.2384 1.32698 20.9352C1.6146 21.548 2.07354 22.0463 2.63803 22.3585C3.27976 22.7135 4.11984 22.7135 5.8 22.7135Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                                <span className={styles.calendarDetailsLabel}>Calendar Status</span>
                                            </div>
                                        </Col>
                                        <Col className={styles.alertContainer}>
                                            {interviewDetailsObj.is_calendar_connected ?
                                                <CustomStatusLabel type="successStatus" className={styles.badgeType} label={"Connected"} />
                                                :
                                                <CustomStatusLabel type="warningStatus" className={styles.badgeType} label={"Not Connected"} />
                                            }
                                        </Col>
                                    </Row>
                                    {interviewDetailsObj.is_calendar_connected &&
                                        <Row>
                                            <Col>
                                                <div className={styles.calendarLabelContainer}>
                                                    <div>
                                                        <svg className={styles.calenderIcon} xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24" fill="none">
                                                            <path d="M19 9.68541H1M14 1V5.3427M6 1V5.3427M7 16.1995L9 18.3708L13.5 13.4853M5.8 22.7135H14.2C15.8802 22.7135 16.7202 22.7135 17.362 22.3585C17.9265 22.0463 18.3854 21.548 18.673 20.9352C19 20.2384 19 19.3264 19 17.5023V8.3826C19 6.55849 19 5.64644 18.673 4.94972C18.3854 4.33687 17.9265 3.83861 17.362 3.52635C16.7202 3.17135 15.8802 3.17135 14.2 3.17135H5.8C4.11984 3.17135 3.27976 3.17135 2.63803 3.52635C2.07354 3.83861 1.6146 4.33687 1.32698 4.94972C1 5.64644 1 6.55849 1 8.3826V17.5023C1 19.3264 1 20.2384 1.32698 20.9352C1.6146 21.548 2.07354 22.0463 2.63803 22.3585C3.27976 22.7135 4.11984 22.7135 5.8 22.7135Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </div>
                                                    <span className={styles.calendarDetailsLabel}>Time Slot Availability</span>
                                                </div>
                                            </Col>
                                            <Col className={styles.alertContainer}>
                                                {interviewDetailsObj.is_time_slot_available ?
                                                    <CustomStatusLabel type="successStatus" className={styles.badgeType} label={"Available"} />
                                                    :
                                                    <CustomStatusLabel type="warningStatus" className={styles.badgeType} label={"Not Available"} />
                                                }
                                            </Col>
                                        </Row>
                                    }
                                    {interviewDetailsObj.is_calendar_connected && !interviewDetailsObj.is_time_slot_available &&
                                        <div className="mt-3">
                                            <CustomCheckBox
                                                id="acceptConditions"
                                                controlId="acceptConditions"
                                                name="condition"
                                                label='I confirm to add RSVP as “Can Attend”'
                                                handleOnChange={() => changeAcknowledgeState()}
                                                type="defaultCheckBox"
                                                ischecked={isAcknowledgeConfirmed}
                                            />
                                        </div>
                                    }
                                    <div className={styles.bottomAlertDiv}>
                                        <CustomAlertBox
                                            alertType="defaultAlert"
                                            alertBodyText="Once you submit your response you will not be able to change your response again."
                                        />
                                    </div>
                                    <Col className="mt-3">
                                        <Row>
                                            <Col className="pl-0">
                                                <CustomButton
                                                    name="backBtn"
                                                    id="adminPanel_interview_rsvpPopUpCancelBtnId"
                                                    buttonType="button"
                                                    disabled={isSubmissionLoading ? true : false}
                                                    type="defaultBtn"
                                                    label="Cancel"
                                                    handleClick={() => closeAsReviewerCanAttendModal()}
                                                />
                                            </Col>
                                            <Col className="pr-0">
                                                <CustomButton
                                                    name="submitBtn"
                                                    id="adminPanel_interview_rsvpPopUpCanAttendBtnId"
                                                    buttonType="button"
                                                    disabled={((interviewDetailsObj.is_calendar_connected && !interviewDetailsObj.is_time_slot_available && !isAcknowledgeConfirmed) || isSubmissionLoading) ? true : false}
                                                    type="secondaryBtn"
                                                    label="Can Attend"
                                                    handleClick={() => submitSuccess()}
                                                    backicon={isSubmissionLoading ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Container>
                            </Modal.Body>
                        }
                    </Modal>

                    {/* Attending RSVP Response Modal End*/}


                    {/* mark RSVP as not attending alert Start */}
                    <CustomConfirmationModal
                        show={failModal}
                        confirmationType='danger'
                        cancelIconclick={closeAlertBox}
                        onSecondaryBtnClick={closeAlertBox}
                        onPrimaryBtnClick={submitFail}
                        isSecondaryBtnDisabled={isSubmissionLoading === true ? true : false}
                        isPrimaryBtnDisabled={isSubmissionLoading === true ? true : false}
                        primaryBtnBackSideIcon={isSubmissionLoading === true ? <i className="fas fa-circle-notch fa-spin"></i> : null}
                        confirmationTopic="RSVP Respond"
                        confirmationMessage="Once you submit your response you will not be able to change your response again."
                        secondaryBtnName="backBtn"
                        secondaryBtnType="button"
                        secondaryBtnCssType="primaryBtn"
                        secondaryBtnLabel="Cancel"
                        primaryBtnName="submitBtn"
                        primaryBtnId="adminPanel_interviews_rsvpModalCantAttendBtnId"
                        primaryBtnType="button"
                        primaryBtnCssType="dangerBtn"
                        primaryBtnLabel="Can't Attend"
                    />
                    {/* mark RSVP as not attending alert End */}

                    <div className={styles.backgroundFixedComponents}>
                        <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb} breacrumbText= {breacrumbText}/>
                    </div>
                    <div className={styles.BodyContainer}>
                        <Col>
                            <div className={styles.searchAndDropDwonBar}>
                                <Row>
                                    <Col sm={3} className="mb-2">
                                        <Select
                                            class="react-select__control"
                                            components={animatedComponents}
                                            value={defaultFilterType}
                                            options={filterType}
                                            onChange={(e) => {
                                                setDefaultFilterType(e);
                                                changeTimeStateType(e);
                                            }}
                                            styles={
                                                {
                                                    ...styles,
                                                    control: (base, state) => ({
                                                        ...base,
                                                        '&:hover': { borderColor: '#24859a' }, // border style on hover
                                                        border: '1px solid #D0D5DD', // default border color
                                                        borderRadius: '6px',
                                                        boxShadow: 'none', // no box-shadow
                                                        height: '44px',
                                                        fontFamily: 'var(--app-primary-font-style)',
                                                        fontWeight: 'var(--app-regular-font-weight)',
                                                        fontSize: 'var(--app-primary-font-size)',
                                                    }),
                                                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                                                        return {
                                                            ...styles,
                                                            background: isDisabled
                                                                ? null
                                                                : isSelected
                                                                    ? 'rgba(45, 166, 192, 0.1)'
                                                                    : isFocused
                                                                        ? 'rgba(45, 166, 192, 0.1)'
                                                                        : null,
                                                            color: isDisabled
                                                                ? '#ccc'
                                                                : isSelected
                                                                    ? '#24859A'
                                                                    : '#24859A',
                                                            cursor: isDisabled ? 'not-allowed' : 'default',

                                                            ':active': {
                                                                ...styles[':active'],
                                                                background:
                                                                    !isDisabled && (isSelected ? 'rgba(45, 166, 192, 0.1)' : 'rgba(45, 166, 192, 0.1)'),
                                                            },
                                                        };
                                                    },
                                                }
                                            }
                                        />
                                    </Col>
                                    <Col sm={9} className="mb-2">
                                        <CustomSearch
                                            placeholder="Search here"
                                            handleOnChange={(e) => searchValues(e.target.value)}
                                        />
                                    </Col>

                                </Row>
                            </div>

                        </Col>
                        {filteredValues.length === 0 && !isLoading && (
                            <div>
                                {noSearchData ? (
                                    <Col>
                                        <p className={styles.infoMessage}>
                                            No records found for your search. Try a different keyword.
                                        </p>
                                    </Col>
                                ) : (
                                    <div>
                                        <Col>
                                            <p className={styles.infoMessage}>Currently no interviews assigned to you to conduct. Learn more
                                                about  <a className={styles.linkText} href='https://hiretrace.io/documentation/interviews/overview' target="_blank">Interviews</a>. </p>
                                        </Col>
                                        <Col xs={{ span: 6, offset: 3 }} sm={{ span: 4, offset: 4 }}>
                                            <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/interview.svg`} fluid />
                                        </Col>
                                    </div>
                                )}
                            </div>
                        )}
                        {filteredValues.length > 0 && !isLoading && (
                            <div>
                                <Col>
                                    <Row>
                                        {filteredValues.map((values, index) => (
                                            <Col sm={6} lg={4} className="mb-4" key={values.interview_id}>
                                                <Card className={styles.interviewCardOuter}>
                                                    <Card.Body className={styles.interviewCardBody}>
                                                        <div className={styles.interviewCardHeaderDiv}>
                                                            <div className={styles.interviewCardHeaderDivLeft}>
                                                                {/* position and interview details */}
                                                                <div className={styles.interviewPositionDetails}>
                                                                    <div className={styles.positionDetails}>
                                                                        <p className={styles.positionName} id="adminPanel_interview_positionNameId">{values.hiring_position} </p>
                                                                        <p className={styles.stageName} id="adminPanel_interview_stageNameId">{values.interview_stage_name} </p>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    {
                                                                        values.interview_type == 0 ? <div variant="success" className={styles.interviewTypeOnline}>
                                                                            <div className={styles.interviewTypeOnlineIcon}>
                                                                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-monitor"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                                                                            </div>
                                                                            Online Interview</div>
                                                                            :
                                                                            values.interview_type == 2 ? <div variant="success" className={styles.interviewTypeOnline}>
                                                                                <div className={styles.interviewTypeOnlineIcon}>
                                                                                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <g clip-path="url(#clip0_8524_6339)">
                                                                                <path d="M7.44457 1.92652L11.5222 4.57701C11.6663 4.67066 11.7384 4.71749 11.7906 4.77995C11.8368 4.83525 11.8715 4.8992 11.8927 4.96808C11.9166 5.04588 11.9166 5.13181 11.9166 5.30366V9.275C11.9166 10.1851 11.9166 10.6401 11.7395 10.9877C11.5837 11.2935 11.3351 11.5421 11.0293 11.6979C10.6817 11.875 10.2267 11.875 9.31659 11.875H3.68325C2.77317 11.875 2.31812 11.875 1.97052 11.6979C1.66475 11.5421 1.41616 11.2935 1.26037 10.9877C1.08325 10.6401 1.08325 10.1851 1.08325 9.275V5.30366C1.08325 5.13181 1.08325 5.04588 1.10718 4.96808C1.12836 4.8992 1.16306 4.83525 1.20927 4.77995C1.26147 4.71749 1.33351 4.67066 1.4776 4.57701L5.55527 1.92652M7.44457 1.92652C7.10264 1.70427 6.93168 1.59314 6.74747 1.5499C6.58465 1.51169 6.41519 1.51169 6.25236 1.5499C6.06816 1.59314 5.8972 1.70427 5.55527 1.92652M7.44457 1.92652L10.7987 4.10668C11.1712 4.34886 11.3575 4.46995 11.4221 4.62351C11.4784 4.75771 11.4784 4.90895 11.4221 5.04315C11.3575 5.19671 11.1712 5.3178 10.7987 5.55998L7.44457 7.74014C7.10265 7.96239 6.93168 8.07352 6.74747 8.11676C6.58465 8.15498 6.41519 8.15498 6.25236 8.11676C6.06816 8.07352 5.8972 7.96239 5.55527 7.74014L2.20118 5.55998C1.82859 5.3178 1.6423 5.19671 1.57778 5.04315C1.52139 4.90895 1.52139 4.75771 1.57778 4.62351C1.6423 4.46995 1.82859 4.34886 2.20118 4.10668L5.55527 1.92652M11.6458 10.7917L8.04756 7.54166M4.95228 7.54166L1.35409 10.7917" stroke="white" stroke-width="1.08333" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                </g>
                                                                                <defs>
                                                                                <clipPath id="clip0_8524_6339">
                                                                                <rect width="15" height="15" fill="white" transform="translate(0 0.5)"/>
                                                                                </clipPath>
                                                                                </defs>
                                                                                </svg>

                                                                                </div>
                                                                                Online Interview via invitation</div>
                                                                                : <div variant="warning" className={styles.interviewTypeInPerson}>
                                                                                    <div className={styles.interviewTypeInPersonIcon}>
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                                                                    </div>
                                                                                    In-person Interview</div>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className={styles.interviewCardHeaderDivRight}>
                                                                <p className={styles.interviewDateTime}>
                                                                    <span className={styles.interviewDate} id="adminPanel_interview_interviewDateId">{moment.tz(values.schedule.date_time, values.schedule.time_zone).format('ddd MMM D YYYY')}</span>
                                                                    <br />
                                                                    <span className={styles.interviewTime} id="adminPanel_interview_interviewTimeId"> {moment.tz(values.schedule.date_time, values.schedule.time_zone).format('HH:mm A')}</span>
                                                                    <br />
                                                                    <span className={styles.interviewTimeZone} id="adminPanel_interview_interviewTimeZoneId"> {`(${values.schedule.time_zone})`}</span>
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className={styles.interviewCardMiddleDiv}>
                                                            <div className={styles.interviewCardMiddleDivLeft}>
                                                                {/* rsvp details */}
                                                                <div className={styles.rsvpContent}>

                                                                    <div className={styles.rsvpTextDiv}>
                                                                        <p className={styles.rsvpText}>{values.rsvp === 0 ? 'Can you attend?' : 'Your RSVP response is   '}</p>
                                                                    </div>
                                                                    <div>

                                                                        {values.rsvp === 0 ?
                                                                            <div className={styles.rsvpActionBox}>
                                                                                <Button variant='light' className={`${styles.rsvpActionBtnYes} ${'ml-2'}`} onClick={() => markAsReviewerCanAttend({ session_id: values.interview_id, rsvp: 1 })} id="adminPanel_interviews_rsvpYesBtnID">Yes</Button>
                                                                                <Button variant='light' className={`${styles.rsvpActionBtnNo}`} onClick={() => timesBtnChecked({ session_id: values.interview_id, rsvp: -1 })} id="adminPanel_interviews_rsvpNoBtnID">No</Button>
                                                                            </div>
                                                                            : values.rsvp === 1 ?
                                                                                <div className={styles.rsvpResponseBox}>
                                                                                    <Button variant="light" className={styles.rsvpResponseLabelAttending} id="adminPanel_interview_rsvpResponseAttendingTextId" >Attending</Button>
                                                                                </div>
                                                                                : values.rsvp === -1 ?
                                                                                    <div className={styles.rsvpResponseBox}>
                                                                                        <Button variant="light" className={styles.rsvpResponseLabelNotAttending} id="adminPanel_interview_rsvpResponseNotAttendingTextId" >Not Attending</Button>
                                                                                    </div>
                                                                                    : null
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className={styles.interviewCardMiddleDivRight}>
                                                                <div onChange={getCurrentTimeDifference(values.schedule.date_time)}>
                                                                    {time_difference > 12 &&
                                                                        <div className={styles.hiddenDiv}></div>
                                                                    }
                                                                    {time_difference <= 12 && (time_difference >= 0 && minute_difference >= 0) &&
                                                                        <div className={styles.timeLeftLabel}>
                                                                            <svg className={styles.remainTimeShowSvg} width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M12 6V12L16 14" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>
                                                                            <span className={styles.remainTimeShowDiv}>{time_difference < 1 ? `${minute_difference} minutes` : (time_difference >= 1 && time_difference < 12) ? `${time_difference}hr  ${minute_difference}min` : `${time_difference} hours`} left</span>
                                                                        </div>
                                                                    }
                                                                    {(time_difference === 0 && minute_difference >= -59 && minute_difference < 0) &&
                                                                        <div className={styles.timeNowLabel}>
                                                                            <svg className={styles.remainTimeShowSvg} width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M9 4.5V9L12 10.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>
                                                                            <span> Now</span>
                                                                        </div>
                                                                    }
                                                                    {overdueTime < -59 &&
                                                                        <div className={styles.timeoverdueLabel}>
                                                                            <svg className={styles.remainTimeShowSvg} width="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                <path d="M9 4.5V9L12 10.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                            </svg>
                                                                            <span > Overdue</span>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={styles.interviewCarddFooterDiv}>
                                                            <div>
                                                                {/* candidate details */}
                                                                <div className={styles.candidateDetails}>
                                                                    <div className={styles.candidateDetailsAvatar}>
                                                                        <Avatar name={values.candidate_name} size="40" round={true} />
                                                                    </div>
                                                                    <div className={styles.candidateDetailsText}>
                                                                        <div className={styles.candidateDetailsTextNameLogo}>
                                                                            <span data-tooltip-id={values.interview_id}>
                                                                                {values.candidate_rsvp === 1 ?
                                                                                    <span>
                                                                                        <svg className={styles.attendIcon} xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                                            <path d="M4.99992 8.27724L6.99992 10.3465L10.9999 6.20793M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                        </svg>
                                                                                    </span>
                                                                                    :
                                                                                    values.candidate_rsvp === 0 ?
                                                                                        <span>
                                                                                            <svg className={styles.pendingIcon} xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                                                <path d="M7.99992 5.51816V8.27724M7.99992 11.0363H8.00659M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                            </svg>
                                                                                        </span>
                                                                                        :
                                                                                        values.candidate_rsvp === -1 ?
                                                                                            <span>
                                                                                                <svg className={styles.xIcon} xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                                                    <path d="M9.99992 6.20793L5.99992 10.3465M5.99992 6.20793L9.99992 10.3465M14.6666 8.27724C14.6666 12.0867 11.6818 15.1749 7.99992 15.1749C4.31802 15.1749 1.33325 12.0867 1.33325 8.27724C1.33325 4.46775 4.31802 1.37955 7.99992 1.37955C11.6818 1.37955 14.6666 4.46775 14.6666 8.27724Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                </svg>
                                                                                            </span>
                                                                                            :
                                                                                            null
                                                                                }
                                                                                <ReactTooltip id={values.interview_id} place="bottom" type="dark" effect="solid">
                                                                                    {values.candidate_rsvp === 1
                                                                                        ? 'Candidate Attending'
                                                                                        : values.candidate_rsvp === 0
                                                                                            ? 'Candidate RSVP Pending'
                                                                                            : values.candidate_rsvp === -1
                                                                                                ? 'Candidate not Attending'
                                                                                                : ''}
                                                                                </ReactTooltip>

                                                                            </span>
                                                                            <p className={styles.candidateName} id="adminPanel_interview_candidateNameId">{values.candidate_name}</p>
                                                                        </div>
                                                                        <p className={styles.candidateEmail} id="adminPanel_interview_candidateEmailId">{values.candidate_email} </p>
                                                                    </div>

                                                                </div>

                                                            </div>
                                                        </div>
                                                        <div className={styles.viewInterviewBtn}>
                                                            <CustomButton
                                                                buttonType="button"
                                                                label="View Interview"
                                                                id="adminPanel_interviewa_viewInterviewBtnId"
                                                                type="secondaryBtn"
                                                                backicon={
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                                                                        <path d="M10.7271 13.369L14.1078 10.0238M14.1078 10.0238L10.7028 6.70237M14.1078 10.0238L7.32212 10.0476M10.6846 1.7024C15.3692 1.68596 19.1803 5.40356 19.197 10.0059C19.2138 14.6082 15.4298 18.3525 10.7453 18.369C6.06074 18.3854 2.24961 14.6678 2.23287 10.0655C2.21613 5.46312 6.00012 1.71885 10.6846 1.7024Z" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                                                                    </svg>
                                                                }
                                                                handleClick={() => startInterview(values.interview_id)}
                                                            />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                </Col>
                            </div>
                        )}
                        <div className={styles.NoContainer}>
                        </div>
                    </div>
                </div>)
            }
        </div>
    )
}

export default Interviews;
